<template>
  <!-- 校本抢课分组选课 -->
  <div class="choseCourse">
    <div class="fl" v-if="list">
      <van-sidebar v-model="activeKey" @change="getIndex">
        <van-sidebar-item
          v-for="item in list.Results"
          :key="item.SubjectGroupID"
          :title="item.SubjectGroupName"
        ></van-sidebar-item>
      </van-sidebar>
    </div>
    <div
      class="content fr"
      style="margin-bottom: 100px;"
      v-if="list&&list.Results[index].Childrens.length>0"
    >
      <div class="content-header">
        <p>{{list.Results[index].SubjectGroupName}}</p>
        <p>
          本次最少选
          <span>{{list.MinOptionalCourse}}</span>点，最多选
          <span>{{list.MaxOptionalCourse}}</span>点，已选
          <span>{{list.SelfSelectCount}}</span>
        </p>
      </div>
      <div class="content-header">
        <p>
          本组最少选
          <span>{{list.Results[index].MinSubjectNum}}</span>点，最多选
          <span>{{list.Results[index].MaxSubjectNum}}</span>点，已选
          <span>{{list.Results[index].SelectNum}}</span>点
        </p>
      </div>
      <div v-for="(item1,j) in list.Results[index].Childrens" :key="item1.SubjectGroupID">
        <div class="content-main">
          <p style="padding-top:25px;">{{item1.SubjectGroupName}}</p>
          <p>
            本组最少选
            <span>{{item1.MinSubjectNum}}</span>点，最多选
            <span>{{item1.MaxSubjectNum}}</span>点，已选
            <span>{{item1.SelectNum}}</span>点
          </p>
          <div
            class="course"
            v-for="item2 in list.Results[index].Childrens[j].Courses"
            :key="item2.AID"
          >
            <div>
              <span>{{item2.SubjectName}}</span>
              <img :src="igmUrl" alt />
              <p class="teacher">教师名称：{{item2.TeacherName?item2.TeacherName:'无'}}</p>
              <p class="cours">{{item2.TimesInfo}}</p>
              <p class="current">当前已选：{{item2.SelectCount}}/{{item2.StudentLimitation}}人</p>
              <p class="diot">点数{{item2.SubjectScore}}点</p>
              <div class="btn" v-if="!item2.IsSelected">选择</div>
              <div class="btn2" v-if="item2.IsSelected">已选</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content fr"
      style="margin-bottom: 100px;" v-if="list&&list.Results[index].Childrens.length === 0">
      <div class="content-header">
        <p>
          本次最少选
          <span>{{list.MinOptionalCourse}}</span>点，最多选
          <span>{{list.MaxOptionalCourse}}</span>点，已选
          <span>{{list.SelfSelectCount}}</span>
        </p>
      </div>
      <div>
        <p style="line-height: 50px;text-align: center;">{{list.Results[index].SubjectGroupName}}</p>
        <div class="content-main" v-for="item1 in list.Results[index].Courses" :key="item1.SubjectGroupID">
          <p>
            本组最少选
            <span>{{list.Results[index].MinSubjectNum}}</span>点，最多选
            <span>{{list.Results[index].MaxSubjectNum}}</span>点，已选
            <span>{{list.Results[index].SelectNum}}</span>点
          </p>
          <div class="course">
            <div>
              <span>{{item1.SubjectName}}</span>
              <img :src="igmUrl" alt />
              <p class="teacher">教师名称：{{item1.TeacherName?item1.TeacherName:'无'}}</p>
              <p class="cours">{{item1.TimesInfo}}</p>
              <p class="current">当前已选：{{item1.SelectCount}}/{{item1.StudentLimitation}}人</p>
              <p class="diot">点数{{item1.SubjectScore}}点</p>
              <div class="btn" v-if="!item1.IsSelected">选择</div>
              <div class="btn2" v-if="item1.IsSelected">已选</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const courseUrl = require("@/assets/csmsTimeTable/onlineCourseSelection/course-class-img.png");
export default {
  data() {
    return {
      igmUrl: courseUrl,
      activeKey: 0,
      index: 0,
      list: {}
    };
  },
  created() {
    this.getSubjec();
  },
  methods: {
    getIndex(_index) {
      this.index = _index;
      console.log(_index);
    },
    async getSubjec() {
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/StudentOnLineSelectCourse/GetSchoolBasedGrabOnLineList",
        {
          classTableID: this.$route.params.classTableID,
          isShow: false,
          studentID: 0
        }
      );
      if (res.success) {
        if (res.data) {
          this.list = res.data;
          console.log(this.list);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.choseCourse {
  width: 100%;
  .van-sidebar-item--select {
    color: #323233;
    font-weight: 500;
    border-color: #4196ff;
  }
  .van-sidebar-item {
    border-bottom: 1px solid #e6e6e6;
    line-height: inherit;
  }
  .fl {
    width: 20%;
    background: rgba(249, 249, 249, 1);
    box-shadow: 0px 4px 8px 0px rgba(151, 151, 151, 0.2);
  }
  .fr {
    width: 78%;
    margin: 10px auto;
  }
  .content {
    background-color: #fff;
    .content-header {
      padding: 15px 0 20px 20px;
      height: 100px;
      width: 100%;
      background-image: url("./../../../../assets/csmsTimeTable/onlineCourseSelection/conheader.png");
      background-size: cover;
      line-height: 35px;
      p:nth-child(1) {
        font-size: 26px;
        color: rgba(51, 51, 51, 1);
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
    }
    .content-main {
      text-align: center;
      p:nth-child(1) {
        font-size: 28px;
        color: #1d2157;
        font-weight: bold;
      }
      p:nth-child(2) {
        font-size: 22px;
        color: rgba(153, 153, 153, 1);
        line-height: 35px;
      }
      p {
        span {
          color: #545efa;
          font-weight: bold;
        }
      }
      .course {
        padding-left: 30px;
        margin-top: 20px;
        padding-top: 25px;
        border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
        div {
          position: relative;
          height: 250px;
          span {
            float: left;
          }
          img {
            position: absolute;
            width: 58px;
            height: 64px;
            left: 0;
            top: 25%;
          }
          .teacher {
            position: absolute;
            left: 20%;
            top: 18%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .cours {
            position: absolute;
            left: 20%;
            top: 38%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .current {
            position: absolute;
            left: 20%;
            top: 58%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .diot {
            position: absolute;
            left: 20%;
            top: 78%;
            font-size: 22px;
            text-align: left;
            font-weight: normal;
            color: #999999;
          }
          .btn {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            border: 1px solid rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: rgba(246, 141, 5, 1);
          }
          .btn2 {
            position: absolute;
            right: 5%;
            top: 25%;
            width: 124px;
            height: 52px;
            background: rgba(255, 149, 0, 1);
            box-shadow: 0px 4px 8px 0px rgba(228, 111, 86, 0.5);
            border-radius: 26px;
            line-height: 52px;
            text-align: center;
            font-weight: normal;
            font-size: 24px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>